module.exports = __webpack_public_path__ + "img/GAME_OXQUIZ2.f66c3d4a.jpg";